import dynamic from "next/dynamic";

export const DynamicContent061 = dynamic(() => import("./Content061"), {
  suspense: true,
});
